import { Helmet } from 'react-helmet-async';

interface TitleProps {
	title: string;
}

// HTML Title Tag
const Title = ({ title }: TitleProps) => {
	return (
		<Helmet>
			<title>ReeferSys - {title}</title>
		</Helmet>
	);
};

export default Title;
